import React, { useState } from 'react'
import { createSelector } from 'reselect'
import { useDispatch, useSelector } from 'react-redux'
import cx from 'classnames'

import { Close, ArrowBack } from '@material-ui/icons'
import { Box, Drawer, IconButton, makeStyles, Typography, useTheme } from '@material-ui/core'
import { useLiterals } from '~/components/Literals'
import useViewportSizes from '~/components/useViewportSize'
import SearchAddress from '~/components/Autocomplete/SearchAddress'

import actions from '~/actions'

import { digitarEndereco, compartilharEndereco } from '~/track'

import ButtonPosition from './ButtonPosition'

const useStyle = makeStyles((theme) => ({
  root: {
    width: theme.gofind.asideWidth,
    position: 'absolute',
    height: '100%',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: (props) => (props.permission === 'denied' ? 350 : 280),
      boxShadow: theme.shadows[4]
    }
  },
  paper: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: 0,
    margin: 0,
    borderRadius: 0,
    overflow: 'hidden',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  backdrop: {
    width: `calc(100% - ${theme.gofind.asideWidth}px)`,
    position: 'absolute',
    height: '100%',
    right: 0,
    zIndex: 1200,
    backdropFilter: 'blur(5px)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: (props) =>
        props.permission === 'denied' ? 'calc(100% - 350px)' : 'calc(100% - 280px)',
      bottom: 0
    }
  },
  boxContent: {
    padding: '16px 8px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    ...theme.gofind.scrollBar
  },
  button: {
    position: 'absolute',
    cursor: 'pointer',
    zIndex: 1,
    '&.close': {
      top: 4,
      right: 4
    },
    '&.back': {
      top: 4,
      left: 4
    }
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  inputAddress: {
    width: '100%'
  }
}))

const selector = createSelector(
  (state) => state.config,
  (state) => state.position,
  (config, position) => ({ config, position })
)

export default function PositionMobile() {
  const {
    config: { showContextViewEstablishment = false },
    position: { showPositionDialog, user, permission }
  } = useSelector(selector)

  const [isExistsValue, setIsExistsValue] = useState(false)

  const { getLiteral } = useLiterals()

  const theme = useTheme()
  const viewport = useViewportSizes()
  const dispatch = useDispatch()

  const isExistPositionUser = user?.lat && user?.lng
  const isMobile = viewport.width < theme.gofind.desktopMaxWidth

  const classes = useStyle({ permission })

  const handleChangeLocation = (location) => {
    dispatch(actions.position.change({ user: location, showPositionDialog: false }))
  }

  const handleShareLocation = (location) => {
    compartilharEndereco(location) // track
    handleChangeLocation(location)
  }

  const handleSearchLocation = (location) => {
    digitarEndereco() // track
    handleChangeLocation(location)
  }

  const handleCloseDialog = () => {
    dispatch(actions.position.change({ showPositionDialog: false }))
  }

  const handleIsChangeValue = (value) => {
    setIsExistsValue(value)
  }

  return (
    <>
      <Drawer
        hideBackdrop
        id="drawer-geolocation"
        anchor={isMobile ? 'top' : 'left'}
        open={showPositionDialog}
        transitionDuration={0}
        classes={{
          root: classes.root,
          paper: classes.paper
        }}
        ModalProps={{
          container: document.getElementById('gofind-finder') || document.body,
          style: { position: 'absolute' },
          disableAutoFocus: true,
          disableEnforceFocus: true
        }}
      >
        {isExistPositionUser && !isMobile ? (
          <IconButton
            size="small"
            onClick={handleCloseDialog}
            className={cx(classes.button, { back: true })}
          >
            <ArrowBack />
          </IconButton>
        ) : null}

        {isExistPositionUser && isMobile ? (
          <IconButton
            onClick={handleCloseDialog}
            size="small"
            className={cx(classes.button, { close: true })}
          >
            <Close />
          </IconButton>
        ) : null}

        <Box className={classes.boxContent}>
          <Typography
            variant="h1"
            color="primary"
            style={{ marginBottom: 16, textAlign: 'center' }}
          >
            {showContextViewEstablishment ? getLiteral('2544') : getLiteral('2507')}
          </Typography>

          <Box className={classes.inputAddress}>
            <SearchAddress
              onChangeValue={handleIsChangeValue}
              onChangeLocation={handleSearchLocation}
              placeholder={getLiteral('3316')}
            />
          </Box>

          <Box style={{ marginTop: 8, visibility: !isExistsValue ? 'visible' : 'hidden' }}>
            <ButtonPosition onChangeLocation={handleShareLocation} />
          </Box>
        </Box>
      </Drawer>
      {showPositionDialog ? <div className={classes.backdrop} /> : null}
    </>
  )
}
